import {
  toCyrillicMap,
  toCyrillicKeyboardMap,
  toLatinKeyboardMap
} from './constants'

export const toCyrillic = (origText: string): string => {
  const output = []
  const text = origText.toLowerCase()

  for (let i = 0; i < text.length; i++) {
    const word1 = text.slice(i, i + 1)
    if (toLatinKeyboardMap[word1]) {
      return origText
    }

    const word4 = text.slice(i, i + 4)
    if (toCyrillicMap[word4]) {
      output.push(toCyrillicMap[word4])
      i += 3
      continue
    }

    const word3 = text.slice(i, i + 3)
    if (toCyrillicMap[word3]) {
      output.push(toCyrillicMap[word3])
      i += 2
      continue
    }

    const word2 = text.slice(i, i + 2)
    if (toCyrillicMap[word2]) {
      output.push(toCyrillicMap[word2])
      i += 1
      continue
    }

    if (toCyrillicMap[word1]) {
      output.push(toCyrillicMap[word1])
      continue
    }

    output.push(word1)
  }

  return output.join('')
}

export const toCyrillicKeyboard = (origText: string): string => {
  const output = []
  const text = origText.toLowerCase()

  for (let i = 0; i < text.length; i++) {
    const char = text.slice(i, i + 1)

    if (toLatinKeyboardMap[char]) {
      return origText
    }

    if (toCyrillicKeyboardMap[char]) {
      output.push(toCyrillicKeyboardMap[char])
      continue
    }

    output.push(char)
  }

  return output.join('')
}
